import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {DateRangeDto} from '../dto/DateRangeDto';
import {Observable} from 'rxjs/index';
import { saveAs } from 'file-saver';
import {Router} from '@angular/router';
import {PaymentDetailsReportDto} from '../dto/PaymentDetailsReportDto';
import {StudioSearchModel} from '../dto/studio-search.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private appConfig: AppConfig, private httpClient: HttpClient,private router: Router) { }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/report/';

  private headersJson = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

  searchRequestData(data: DateRangeDto): Observable<Object> {

    return this.httpClient.post(this.baseUrl + 'searchPaymentReportDetail', data);
  }

  searchStudioStatusData(criteria: StudioSearchModel) {

    return this.httpClient.post(this.baseUrl + 'searchStudioStatusData', criteria);
  }

  printExcelReport(dateRangeDto: DateRangeDto): any{
    return this.httpClient.post(this.baseUrl + 'printExcelReport',dateRangeDto, {headers: this.headersJson, responseType: 'blob'})
      .subscribe(res => {
        const blobb = new Blob([res], {type: res.type});
        saveAs(blobb, 'paymentReport.xls');
        this.router.navigate(['/dashboard/dashHome'] );
      }, error1 => {
        alert('Sorry file not available!');
      });
  }

  exportAsPDF(dto: PaymentDetailsReportDto[]): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'exportAsPDF', dto, {responseType: 'arraybuffer'});
  }

  studioReportExportPDF(dto: StudioSearchModel[]) {

    return this.httpClient.post(this.baseUrl + 'studioReportPDF', dto, {responseType: 'arraybuffer'});
  }

  exportAsExcel(dto: PaymentDetailsReportDto[]): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'exportAsExcel', dto, {responseType: 'arraybuffer'});
  }

  studioReportExportExcel(dto: StudioSearchModel[]) {
    return this.httpClient.post(this.baseUrl + 'studioExportExcel', dto, {responseType: 'arraybuffer'});
  }

}
